import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get, patch, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface GetBannerListParameter extends ApiParameter {
    startDate: string;
    endDate: string;
    persona: string;
    rank: number;
    description: string;
    pageRelativeURL: string;
    customerNumber: string;
    dc: string;
    siteName: string;
    neverExpire: boolean;
    sortOption: string;
    contentType: string;
}

export interface BannerContentRow {
    id: string;
    startDate: Date;
    endDate: Date;
    persona: string;
    rank: number;
    description: string;
    bannerPages: string;
    richContent: string;
    websiteList: string;
    modifiedOn: Date;
}

export interface GetBannerListModel extends BaseModel {
    colBannerContent: BannerContentRow[];
}

const getBannerListUrl = "/api/v2/getbannerlist";
export async function getBannerList(parameter: GetBannerListParameter): Promise<ServiceResult<GetBannerListModel>> {
    try {
        const bannerModel = await patch<GetBannerListModel>(`${getBannerListUrl}`, parameter as any);
        return {
            result: bannerModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export interface BannerActionParameter extends ApiParameter {
    parameter: string
}

const duplicateBannerUrl = "/api/v2/duplicateBannerRecordByID";
export async function duplicateBanner(parameter: BannerActionParameter) {
    const response = await get<string>(`${duplicateBannerUrl}`, parameter as any);
    return response;
}

const deleteBannerUrl = "/api/v2/deleteBannerRecordByID";
export async function deleteBanner(parameter: BannerActionParameter) {
    const response = await get<string>(`${deleteBannerUrl}`, parameter as any);
    return response;
}
